import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=141074f8&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=141074f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141074f8",
  null
  
)

export default component.exports